module.exports = "./dist/start.svg?522b39940c4378c6d1eee62cde62273a";


//////////////////
// WEBPACK FOOTER
// ./src/img/start.svg
// module id = 8
// module chunks = 0